import { MAX_STUDENTS, studentLimitMessage } from '../constants/formConfig';
import { countEnteredStudents } from './pricing';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[\d\s()+.-]{7,}$/;
/** Mockup: unique 3–5 letter code, letters only */
const SCHOOL_CODE_RE = /^[A-Za-z]{3,5}$/;

export function validatePage1(form) {
  const errors = {};
  const { school, contacts } = form;

  if (!school.name.trim()) errors.schoolName = 'School name is required.';
  if (!school.acsiId.trim()) errors.acsiId = 'ACSI ID # is required.';
  if (!school.address1.trim()) errors.address1 = 'Street address is required.';
  if (!school.city.trim()) errors.city = 'City is required.';
  if (!school.state.trim()) errors.state = 'State / Province is required.';
  if (!school.zip.trim()) errors.zip = 'Zip / Postal code is required.';
  if (!school.country.trim()) errors.country = 'Country is required.';

  if (!school.schoolCode.trim()) {
    errors.schoolCode = 'School code is required.';
  } else if (!SCHOOL_CODE_RE.test(school.schoolCode.trim())) {
    errors.schoolCode = 'School code must be 3–5 letters only.';
  }

  const contact = contacts[0] || {};
  if (!contact.firstName?.trim()) {
    errors.contact_0_firstName = 'First name is required.';
  }
  if (!contact.lastName?.trim()) {
    errors.contact_0_lastName = 'Last name is required.';
  }
  if (contact.phone?.trim() && !PHONE_RE.test(contact.phone.trim())) {
    errors.contact_0_phone = 'Enter a valid phone number.';
  }
  if (!contact.email?.trim()) {
    errors.contact_0_email = 'Email is required.';
  } else if (!EMAIL_RE.test(contact.email.trim())) {
    errors.contact_0_email = 'Enter a valid email address.';
  }

  contacts.slice(1).forEach((extra, index) => {
    const i = index + 1;
    const prefix = `contact_${i}`;
    if (!extra.firstName.trim()) {
      errors[`${prefix}_firstName`] = 'First name is required.';
    }
    if (!extra.lastName.trim()) {
      errors[`${prefix}_lastName`] = 'Last name is required.';
    }
    if (extra.phone.trim() && !PHONE_RE.test(extra.phone.trim())) {
      errors[`${prefix}_phone`] = 'Enter a valid phone number.';
    }
    if (!extra.email.trim()) {
      errors[`${prefix}_email`] = 'Email is required.';
    } else if (!EMAIL_RE.test(extra.email.trim())) {
      errors[`${prefix}_email`] = 'Enter a valid email address.';
    }
  });

  return errors;
}

export function validatePage2(form) {
  const errors = {};

  if (!form.registrationMethod) {
    errors.registrationMethod = 'Select a registration method.';
  }

  const isFilled = (student) =>
    student.firstName.trim() ||
    student.lastName.trim() ||
    student.gradeLevel ||
    student.tests.reasoning ||
    student.tests.computation;

  // Validate only rows that have any data — blank trailing rows are ignored.
  form.students.forEach((student, index) => {
    if (!isFilled(student)) return;

    const prefix = `student_${index}`;
    if (!student.firstName.trim()) {
      errors[`${prefix}_firstName`] = 'Required';
    }
    if (!student.lastName.trim()) {
      errors[`${prefix}_lastName`] = 'Required';
    }
    if (!student.gradeLevel) {
      errors[`${prefix}_gradeLevel`] = 'Required';
    }
    if (!student.tests.reasoning && !student.tests.computation) {
      errors[`${prefix}_tests`] = 'Select at least one test';
    }
  });

  const enteredStudents = countEnteredStudents(form.students);
  if (enteredStudents > MAX_STUDENTS) {
    errors.students = studentLimitMessage(enteredStudents);
  }

  if (!form.acceptTerms) {
    errors.acceptTerms = 'You must accept the Terms and Conditions.';
  }
  if (!form.acceptCancellation) {
    errors.acceptCancellation = 'You must accept the Cancellation Policy.';
  }

  return errors;
}

export function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}
